import axios from 'axios';
import { useEffect, useState } from 'react';
import { useLinkedIn } from 'react-linkedin-login-oauth2';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useLocalStorage from 'react-use-localstorage';
import { LinkedInApi, NodeServer } from '../config';
import linkedinImg from '../images/linkedin-option.svg';
import '../styles/SignIn.scss';
import Loading from './Loading';

function Login(props: {
  title: string;
  onProfileLoad: (load: boolean) => void;
}) {
  const [, setUserName] = useLocalStorage('userName', '');
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const { linkedInLogin } = useLinkedIn({
    clientId: LinkedInApi.clientId,
    redirectUri: LinkedInApi.redirectUrl,
    scope: LinkedInApi.scope,
    onSuccess: async (code: string) => {
      setLoading(true);
      props.onProfileLoad(true);
      const nftId = searchParams.get('id');
      const response = await getUserCredentials(code, nftId);
      setLoading(false);
      props.onProfileLoad(false);
      setUserName(response.data.userName);
      navigate('/user-profile');
    },
    onError: (error: any) => {
      console.log(error);
    },
  });

  const getUserCredentials = async (code: string, nftId: string | null) => {
    let loginUrl = `${NodeServer.baseURL}${NodeServer.linkedinLogin}?code=${code}`;
    if (nftId) {
      loginUrl += `&nftId=${nftId}`;
    }
    const user = await axios.get(loginUrl, { withCredentials: true });
    return user;
  };

  useEffect(() => {
    document.title = props.title;
  });

  return loading ? (
    <div className="loading-container">
      <Loading />
    </div>
  ) : (
    <div className="login-page">
      <div className="login-title">
        <h1 className="sign-in">SIGN IN</h1>
        <h1 className="sign-in to-the-future">TO THE FUTURE</h1>
      </div>
      <div className="login-container">
        <button className="linkedin-button" onClick={linkedInLogin}>
          <div className="linkedin-container">
            <img src={linkedinImg} alt="Linkedin"></img>
          </div>
          <span className="btn-text"> Continue with Linkedin</span>
        </button>
        <p className="privacy-policy">
          For more information about how we use your data, see our{' '}
          <a
            href="https://www.softserveinc.com/uk-ua/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>{' '}
          and{' '}
          <a
            href="https://www.softserveinc.com/uk-ua/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
        </p>
      </div>
    </div>
  );
}

export default Login;
